export default function ioAnimations() {
  //add animation classes
  const animatedEls = document.querySelectorAll('.animate');

  const options = {
    rootMargin: '-25%',
  };

  const observer = new IntersectionObserver(callback, options);

  function callback(entries, observer) {
    //console.log(observer);

    entries.forEach((entry) => {
      //if in view
      if (entry.intersectionRatio > 0) {
        //animate on entry
        entry.target.classList.add('animate-in', 'animate-toggle');
        //console.log("in the view");
      } else {
        //animate on entry/exit
        entry.target.classList.remove('animate-toggle');
        //console.log("out of view");
      }
    });
  }

  animatedEls.forEach((animatedEl) => {
    observer.observe(animatedEl);
  });
}
